// extracted by mini-css-extract-plugin
export default {"editableInput":"styles_editableInput__KiO5k","editableButton":"styles_editableButton__T+7Ml"};